// External Imports
import { Button, Stack, Title, pxToRem } from '@lessonnine/design-system.lib';
import { h } from 'preact';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Internal Imports
import { useStore } from '../../state/context';

// Component Definition
function HelpSection() {
  const { t } = useStore();
  return (
    <Stack align="center" alignItems="center" gap={tokens.space.x8} padding={[pxToRem(64), 0]}>
      <Title as="h2" size={{ medium: 'default', small: 'small' }}>
        {t.support.headline}
      </Title>
      <Button
        as="a"
        color="secondary-emphasis"
        href={t.support.cta.link}
        size={{ medium: 'large', xxxsmall: 'default' }}
      >
        {t.support.cta.text}
      </Button>
    </Stack>
  );
}

// Module Exports
export { HelpSection };
